export const LANDING = "/";
export const BROWSE = "/browse";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/login";
export const WATCHLIST = "/watchlist";
